import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=1ccf87a4&scoped=true&"
import script from "./DefaultButton.vue?vue&type=script&lang=js&"
export * from "./DefaultButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccf87a4",
  null
  
)

export default component.exports